import { CostBasis } from ".";

export const enumLabels: any = {
  [CostBasis.Employee]: 'Employee',
  [CostBasis.Device]: 'Device',
  [CostBasis.Fixed]: 'Fixed',
  [CostBasis.License]: 'License',
}

export const costBasisDropdownOptions: any = Object.entries(enumLabels).map((item) => ({
  value: item[0],
  label: item[1],
}));

export const EmptyGuid = '00000000-0000-0000-0000-000000000000';

export const profilePic = 'https://getwindow.netlify.app/assets/1-a8e0947d.png'